export default __webpack_public_path__ + "static/4-d4d82bff01898c3e4cb5e5918a60b9aa.webp";